import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import navLinks from "../../utils/navigation";
import "./navigation.scss";

const Navigation = () => {
	const [openNav, setOpenNav] = useState(false);
	const location = useLocation();
	useEffect(() => {
		setOpenNav(false);
	}, [location.pathname]);
	useEffect(() => {
		document.addEventListener("keydown", (e) => {
			if (e.key === "Escape") setOpenNav(false);
		});
		return () => {
			document.removeEventListener("keydown", (e) => {
				if (e.key === "Escape") setOpenNav(false);
			});
		};
	}, []);

	return (
		<section className={`navigation ${openNav && "navigation-open"}`}>
			<button
				className={`navigation-btn ${openNav && "navigation-btn-open"}`}
				onClick={() => setOpenNav((p) => !p)}
			>
				<span></span>
			</button>
			{openNav && (
				<nav className="navigation-nav" data-aos="zoom-out">
					<ul className="navigation-nav-ul">
						{navLinks
							.filter(
								(p) =>
									p.route !== "/admin" &&
									p.route !== "/notable-alumni"
							)
							.map((navLink) => (
								<li className="navigation-nav-li">
									<Link
										to={navLink.route}
										className="navigation-nav-a"
									>
										{navLink.text}
									</Link>
								</li>
							))}
					</ul>
				</nav>
			)}
		</section>
	);
};

export default Navigation;
